// From the .env file
export const APP_ID = import.meta.env.VITE_APP_ID;
export const APP_DATA_SOURCE = import.meta.env.VITE_DATASOURCE ?? "VidApp";
export const CODE_VERSION = import.meta.env.VITE_CODE_VERSION ?? "DEV";
export const ENABLE_SENTRY = import.meta.env.VITE_ENABLE_SENTRY ?? "true";